import {Device} from "../../types/device";
import {Link} from "react-router-dom";

type Props = {
    devices?: Device[];
};

export default function PhoneRelatedGrid({devices}: Props) {
    return (
        <div className="col-span-2 flex flex-col gap-6">
            <h2 className="text-xl font-semibold text-center">Related</h2>

            <div className="grid grid-cols-2">
                {devices?.map((device, i) => (
                    <div
                        key={i}
                        className={`p-6 flex flex-col items-center
                    ${i % 2 === 0 ? "border-r border-gray-300" : ""}
                    ${i < 2 ? "border-b border-gray-300" : ""}
                `}
                    >
                        <Link to={`/phones/${device.id}`}>
                            <img
                                src={device?.image_url ?? ""}
                                className="w-28 object-contain"
                                alt="related"
                            />
                            <p className="text-sm mt-2 text-center">
                                {device.brand} {device.model}
                            </p>
                            <p className="text-red-500 text-sm">
                                from €1099 to €1240
                            </p>
                        </Link>
                    </div>
                ))}
            </div>

            <div className="flex justify-center">
                <button className="bg-[#1B4498] text-white px-10 py-3 rounded-full">
                    More
                </button>
            </div>
        </div>
    );
}

